import styled from '@emotion/styled';

import { authLayout } from 'design-system/tokens';

export type AuthShellVariant = 'login' | 'onboarding';

export const Container = styled.div<{ variant: AuthShellVariant }>`
  display: flex;
  width: 100%;

  ${({ variant }) =>
    variant === 'onboarding'
      ? `
    align-items: flex-start;
    justify-content: flex-start;
    gap: 54px;
    max-width: 1376px;
    padding-left: 26px;
  `
      : `
    align-items: center;
    justify-content: center;
    gap: 241px;
    max-width: ${authLayout.contentWidth};
  `}

  @media (max-width: 1280px) {
    gap: ${({ variant }) => (variant === 'onboarding' ? '40px' : '120px')};
  }

  @media (max-width: ${authLayout.tabletBreakpoint}) {
    gap: ${({ variant }) => (variant === 'onboarding' ? '32px' : '48px')};
  }

  @media (max-width: ${authLayout.mobileBreakpoint}) {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    padding-left: 0;
  }
`;

export const Shield = styled.img<{ variant: AuthShellVariant }>`
  flex-shrink: 0;

  ${({ variant }) =>
    variant === 'onboarding'
      ? `
    width: 260px;
    height: 313px;
    /* No Figma a imagem começa 43px abaixo do topo do stepper. */
    margin-top: 43px;
  `
      : `
    width: 368px;
    height: 494px;
  `}

  @media (max-width: ${authLayout.tabletBreakpoint}) {
    width: ${({ variant }) => (variant === 'onboarding' ? '220px' : '300px')};
    height: auto;
  }

  @media (max-width: ${authLayout.mobileBreakpoint}) {
    display: none;
  }
`;
